export * from "./ThankYou"
export { default } from "./ThankYou"
